<div class="profile-information block">
  <button class="profile-menu-btn" *ngIf="isMy">
    <svg viewBox="0 0 20 20">
      <use href="#menu-dots" />
    </svg>

    <div class="options-menu">
      <a [routerLink]="settings" class="menu-item d-flex">
        <div class="icon">
          <svg viewBox="0 0 15 15">
            <use href="#sub-edit-profile" />
          </svg>
        </div>
        Edit profile
      </a>
      <!-- <a href="#" class="menu-item d-flex">
          <div class="icon">
            <svg viewBox="0 0 15 15">
              <use href="#sub-network" /></svg>
          </div>
          Network
        </a>
        <a href="#" class="menu-item d-flex">
          <div class="icon">
            <svg viewBox="0 0 15 15">
              <use href="#sub-events" /></svg>
          </div>
          Events
        </a>
        <a href="#" class="menu-item d-flex">
          <div class="icon">
            <svg viewBox="0 0 15 15">
              <use href="#sub-gallery" /></svg>
          </div>
          Gallery
        </a>
        <a href="#" class="menu-item d-flex">
          <div class="icon">
            <svg viewBox="0 0 15 15">
              <use href="#sub-invite" /></svg>
          </div>
          Invite students and educators
        </a>
        <a href="#" class="menu-item d-flex">
          <div class="icon">
            <svg viewBox="0 0 15 15">
              <use href="#teacher" /></svg>
          </div>
          <div>
            Become
            <div class="hint">
              Tutor, admissions consultant, coach
            </div>
          </div>
        </a>
        <a href="#" class="menu-item d-flex">
          <div class="icon">
            <svg viewBox="0 0 15 15">
              <use href="#search-people" /></svg>
          </div>
          <div>
            Find
            <div class="hint">
              Tutor, admissions consultant, coach
            </div>
          </div>
        </a> -->
    </div>
  </button>

  <div class="d-flex flex-column align-items-center profile-top">
    <div class="background" *ngIf="isDefaultBg; else bg"></div>
    <ng-template #bg>
      <div class="background" [style.background-image]="'url('+(organization.icon_bg | baseUrl) + ')'"></div>
    </ng-template>
    <!-- <div class="background" [style.background-image]="'url('+(organization.icon_bg | baseUrl) + ')'"></div> -->
    <div class="profile-avatar">
      <div class="avatar rounded-circle">
        <app-avatar [src]="organization.icon" [placeholder]="organization | initials" class="ava"></app-avatar>
      </div>
    </div>
    <div class="profile-name d-flex align-items-center">
      {{ organization.name }}
      <!--        <div class="status online" *ngIf="organization.is_online"></div>-->
      <div *ngIf="organization.is_creditable" class="icon verified">
        <svg viewBox="0 0 20 20">
          <use href="#new-verified"></use>
        </svg>
      </div>
    </div>
    <div class="profile-verified" *ngIf="organization.is_creditable">Verified Organization</div>
    <div class="profile-actions d-flex">
      <ng-container *ngIf="isAuthView">
        <ng-container *ngIf="!isMy; else ownerActions">
          <button class="action d-flex align-items-center justify-content-center" (click)="onMessage(); false">
            <span class="icon">
              <svg viewBox="0 0 18 20">
                <use href="#new-edit"></use>
              </svg>
            </span>
            <div>Message</div>
          </button>
          <button
            class="action d-flex align-items-center justify-content-center"
            *ngIf="!(organization.is_friend || organization.friend_request); else disconnect"
            (click)="onSubscribe(); false"
          >
            <span class="icon">
              <svg viewBox="0 0 16 20">
                <use href="#new-follow"></use>
              </svg>
            </span>
            <div>Follow organization</div>
          </button>
          <ng-template #disconnect>
            <button class="action d-flex align-items-center justify-content-center" (click)="onUnsubscribe(); false">
              <span class="icon">
                <svg viewBox="0 0 20 20">
                  <use href="#new-unfollow"></use>
                </svg>
              </span>
              <div>Unfollow organization</div>
            </button>
          </ng-template>
        </ng-container>
        <ng-template #ownerActions>
          <a [routerLink]="settings" class="action d-flex align-items-center justify-content-center">
            <span class="icon">
              <svg viewBox="0 0 20 20">
                <use href="#new-edit-info"></use>
              </svg>
            </span>
            <div>Edit information</div>
          </a>
          <button class="action d-flex align-items-center justify-content-center" (click)="openInviteDialog(); false">
            <span class="icon">
              <svg viewBox="0 0 20 20">
                <use href="#new-invite"></use>
              </svg>
            </span>
            <div>Invite</div>
          </button>
        </ng-template>
      </ng-container>
    </div>
  </div>
  <div class="enumerations">
    <div class="enumeration-item d-flex" *ngIf="organization?.org?.member as member">
      <div class="icon">
        <svg viewBox="0 0 20 20">
          <use href="#new-education" />
        </svg>
      </div>
      <span> {{ member }} </span>
    </div>
    <div class="enumeration-item d-flex" *ngIf="organization.location">
      <div class="icon">
        <svg viewBox="0 0 20 20">
          <use href="#new-location" />
        </svg>
      </div>
      <span> Located in <a>{{organization.location?.country?.name}}, {{organization.location?.city?.name}}</a> </span>
    </div>
    <div class="enumeration-item d-flex" *ngIf="organization?.org?.www">
      <div class="icon">
        <svg viewBox="0 0 20 20">
          <use href="#earth" />
        </svg>
      </div>
      <span>
        Website
        <a target="_BLANK" [href]="organization?.org?.www | linkPrefix: 'add'"
          >{{ organization?.org?.www | linkPrefix: 'cut' }}</a
        >
      </span>
    </div>
    <div class="enumeration-item d-flex" *ngIf="organization.org?.address">
      <div class="icon">
        <svg viewBox="0 0 20 20">
          <use href="#call" />
        </svg>
      </div>
      <span> {{ organization.org?.address }} </span>
    </div>
    <div class="enumeration-item d-flex" *ngIf="organization.org?.counts?.members">
      <div class="icon">
        <svg viewBox="0 0 20 20">
          <use href="#new-members" />
        </svg>
      </div>
      <span> Members <a>{{ organization.org?.counts?.members }}</a> </span>
    </div>
  </div>
  <div class="about-block" *ngIf="organization.org.about">
    <div class="title">About us</div>
    <div> {{organization.org?.about | textTruncate:120}} <span class="more-about" (click)="onAbout()">more</span> </div>
  </div>
</div>
